$( window ).on("load", function() {
$('[data-bsub-selling-plan-group]').click(function(){
console.log('testings')
   $('#bwpFrame').hide();
})
$('[data-bsub-purchase-option-one-time]').click(function(){
  console.log('gsgsgg')
       $('#bwpFrame').show();
})

  var input_val = $('.bsub-widget__group-label input:checked').val();
if(input_val == 'once'){
    $('#bwpFrame').show();
}
else{
   $('#bwpFrame').hide();
}
})
$(document).on('click', '.atc-btn2', function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  console.log("Redirecting to product page");

  window.location.href = "https://puresleep.com/products/puresleep-anti-snoring-dental-device";
})
 let elements = document.getElementsByClassName("atc-btn");

    for(let i = 0; i < elements.length; i++) {
        elements[i].onclick = function () {
          console.log('btn click11111111111111')
            var data_id = elements[i].getAttribute("data-id");
            var qty = 1;
            var xhttp = new XMLHttpRequest();
            xhttp.open("POST", "/cart/add.js", true); 
            xhttp.setRequestHeader("Content-Type", "application/json");
            xhttp.onreadystatechange = function() {
               if (this.readyState == 4 && this.status == 200) {
                   // Response
                   var response = this.responseText;
                   if(response){
                     window.location.href="/cart";
                   }
               }
            };
            var data = {id:data_id,quantity: qty};
            xhttp.send(JSON.stringify(data));
        }
    }

document.addEventListener("DOMContentLoaded", function() {
  // Target the third-party app element
  const appElement = document.querySelector(".bsub-widget"); // Replace with the app's actual unique selector
  
  if (appElement && appElement.parentElement) {
    // Add the data attribute to the parent element
    appElement.parentElement.setAttribute("data-spark", "b2c-only");
  }
});
  
  